module.exports = __webpack_public_path__ + "img/Picture26.df340a83.png";